<template>
    <component :is="pagemain" v-on="$listeners"></component>
</template>

<script>
    export default {
        name: 'index',
        computed: {
            pagemain: function () {

                let folder = this.$route.params.root || 'home';
                folder = folder.toLowerCase();

                let filename = this.$route.params.sub || folder;
                if ((folder == "college") || (folder == "course") || (folder == "learn")) {
                    filename = folder;
                }

                this.$emit('showheaderfooter', folder != 'zx');
                this.$emit('hidepop');

                return () => import('@/views/' + folder + '/' + filename);

            }
        },
        mounted() {
            let folder = this.$route.params.root || 'home';
            folder = folder.toLowerCase();
            if (((folder == "course") || (folder == "member")) && (this.$store.state.islogin == 0)) {
                this.$router.replace('/');
            }
        }
    };
</script>
